import { tooltipVariantOptions, TooltipVariant } from '../types/tooltip.js';

/**
 * Returns true if tooltipVariant is a valid TooltipVariant
 * @param tooltipVariant - tooltip variant
 */
export const isValidTooltipVariant = (
  tooltipVariant: string,
): tooltipVariant is TooltipVariant =>
  (tooltipVariantOptions as unknown as string[]).includes(tooltipVariant);
